
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/load-shedding-solutions",
      function () {
        return require("private-next-pages/load-shedding-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/load-shedding-solutions"])
      });
    }
  